import ProjectCard from '@/components/projects/ProjectCard'
import cn          from 'classnames'
import styles      from './ProjectsList.module.sass'

const ProjectsList = ({
	className,
	data,
	nbImagesWithHighPriority = 0,
}) => {
	return (<section className={cn(styles['projects-list'], className)}>
		{data.docs.map((project, index) => <ProjectCard
			project={project}
			key={index}
			isImagePriority={index < nbImagesWithHighPriority}
		/>)}
	</section>)
}
export default ProjectsList
